<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2cbo4h/tc-custom/9781626814523.jpg?1704317917104" alt="This image is the cover for the book Michael Gray Novels, The Michael Gray Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Michael Gray Novels, The Michael Gray Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>From “a neglected master”: All four murder mysteries featuring the psychoanalyst turned sleuth in 1950s San Francisco (Ray Bradbury, author of <i>Fahrenheit 451</i>).</b><br/>  <br/> Dr. Michael Gray is constantly drawn into the lives, and murders, of his clientele. Fortunately, this unconventional detective’s eye for human behavior just might keep him out of mortal danger . . .<br/>  <br/><i>The Murder of Eleanor Pope</i>: When a woman is killed in a foggy San Francisco park, the police suspect it was a robbery gone terribly wrong, but Dr. Gray’s troubled new patient may be the key to the truth.<br/>  <br/><i>The Murder of Ann Avery</i>: Everyone thinks a juvenile delinquent murdered Ann Avery, but Dr. Gray has a whole list of potential suspects—if someone doesn’t kill them first.<br/>  <br/><i>Murder of a Mistress</i>: When a call girl is murdered, four people confess to the deed. But the evidence points to one of Dr. Gray’s patients. Heiress Eileen Herrick may be a wild child, but Gray is out to prove she’s no killer.<br/>  <br/><i>Murder of a Wife</i>: Dr. Gray’s new patient is housewife Karen Champion. He was warned she’s a pathological liar, but he finds it difficult to ignore her claim that her husband is trying to kill her . . .<br/>  <br/> “Kuttner is magic.” —Joe R. Lansdale, author of <i>The Thicket</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry Kuttner
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27745a0d